var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotes = function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#F8F9FA",
    rx: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    d: "M40.077 28.743a1.37 1.37 0 0 0-1.68-.972l-17.38 4.658a1.37 1.37 0 0 0-.971 1.677l6.671 24.877a1.37 1.37 0 0 0 1.677.971l17.383-4.657a1.37 1.37 0 0 0 .969-1.677z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    d: "M39.923 21.911a1.37 1.37 0 0 1 1.68-.971l17.38 4.657a1.37 1.37 0 0 1 .971 1.68l-6.671 24.877a1.37 1.37 0 0 1-1.677.972l-17.383-4.657a1.37 1.37 0 0 1-.969-1.678z"
  })));
};
export default SvgQuotes;